import { useState, useEffect } from 'react';
import { Clock, Copy, Coffee } from '../../icons/wp-icons';

const WOCHENTAGE = [
  { key: 'montag', label: 'Montag' },
  { key: 'dienstag', label: 'Dienstag' },
  { key: 'mittwoch', label: 'Mittwoch' },
  { key: 'donnerstag', label: 'Donnerstag' },
  { key: 'freitag', label: 'Freitag' },
  { key: 'samstag', label: 'Samstag' },
  { key: 'sonntag', label: 'Sonntag' }
];

const DEFAULT_ZEITEN = {
  montag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
  dienstag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
  mittwoch: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
  donnerstag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
  freitag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
  samstag: { aktiv: false, von: '09:00', bis: '13:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
  sonntag: { aktiv: false, von: '09:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' }
};

function OeffnungszeitenStep({ data = {}, onDataChange, onboardingData }) {
  const existingData = onboardingData?.branchenKonfiguration?.oeffnungszeiten;

  const [zeiten, setZeiten] = useState(() => {
    if (data.oeffnungszeiten) return data.oeffnungszeiten;
    if (existingData) {
      // Bestehende Daten mit Mittagspause-Feldern ergänzen falls nicht vorhanden
      const updated = {};
      for (const key of Object.keys(existingData)) {
        updated[key] = {
          ...existingData[key],
          mittagspause: existingData[key].mittagspause ?? false,
          pauseVon: existingData[key].pauseVon ?? '12:00',
          pauseBis: existingData[key].pauseBis ?? '13:00'
        };
      }
      return updated;
    }
    return DEFAULT_ZEITEN;
  });

  // Daten an Parent übergeben
  useEffect(() => {
    // Mindestens ein Tag muss aktiv sein
    const hasActiveDay = Object.values(zeiten).some(z => z.aktiv);
    onDataChange({ oeffnungszeiten: zeiten }, hasActiveDay);
  }, [zeiten]);

  const handleToggle = (tag) => {
    setZeiten(prev => ({
      ...prev,
      [tag]: { ...prev[tag], aktiv: !prev[tag].aktiv }
    }));
  };

  const handleMittagspauseToggle = (tag) => {
    setZeiten(prev => ({
      ...prev,
      [tag]: { ...prev[tag], mittagspause: !prev[tag].mittagspause }
    }));
  };

  const handleTimeChange = (tag, field, value) => {
    setZeiten(prev => ({
      ...prev,
      [tag]: { ...prev[tag], [field]: value }
    }));
  };

  const copyToAll = (sourceTag) => {
    const sourceZeit = zeiten[sourceTag];
    setZeiten(prev => {
      const updated = { ...prev };
      WOCHENTAGE.forEach(({ key }) => {
        if (key !== 'samstag' && key !== 'sonntag') {
          updated[key] = { ...sourceZeit };
        }
      });
      return updated;
    });
  };

  const applyPreset = (preset) => {
    switch (preset) {
      case 'standard':
        setZeiten(DEFAULT_ZEITEN);
        break;
      case 'mitPause':
        setZeiten({
          montag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          dienstag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          mittwoch: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          donnerstag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          freitag: { aktiv: true, von: '08:00', bis: '17:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          samstag: { aktiv: false, von: '09:00', bis: '13:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          sonntag: { aktiv: false, von: '09:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' }
        });
        break;
      case 'vollzeit':
        setZeiten({
          montag: { aktiv: true, von: '07:00', bis: '18:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          dienstag: { aktiv: true, von: '07:00', bis: '18:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          mittwoch: { aktiv: true, von: '07:00', bis: '18:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          donnerstag: { aktiv: true, von: '07:00', bis: '18:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          freitag: { aktiv: true, von: '07:00', bis: '18:00', mittagspause: true, pauseVon: '12:00', pauseBis: '13:00' },
          samstag: { aktiv: true, von: '08:00', bis: '14:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          sonntag: { aktiv: false, von: '09:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' }
        });
        break;
      case 'halbtags':
        setZeiten({
          montag: { aktiv: true, von: '08:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          dienstag: { aktiv: true, von: '08:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          mittwoch: { aktiv: true, von: '08:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          donnerstag: { aktiv: true, von: '08:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          freitag: { aktiv: true, von: '08:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          samstag: { aktiv: false, von: '09:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' },
          sonntag: { aktiv: false, von: '09:00', bis: '12:00', mittagspause: false, pauseVon: '12:00', pauseBis: '13:00' }
        });
        break;
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Ihre Öffnungszeiten
        </h3>
        <p className="text-gray-600 text-sm mb-6">
          Ihr Assistent schlägt Kunden nur Termine innerhalb dieser Zeiten vor.
        </p>
      </div>

      {/* Vorlagen */}
      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => applyPreset('standard')}
          className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition"
        >
          Standard (Mo-Fr 8-17)
        </button>
        <button
          onClick={() => applyPreset('mitPause')}
          className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition"
        >
          Mit Mittagspause
        </button>
        <button
          onClick={() => applyPreset('vollzeit')}
          className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition"
        >
          Vollzeit (inkl. Sa)
        </button>
        <button
          onClick={() => applyPreset('halbtags')}
          className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition"
        >
          Halbtags
        </button>
      </div>

      {/* Zeiten-Tabelle */}
      <div className="space-y-3">
        {WOCHENTAGE.map(({ key, label }) => (
          <div
            key={key}
            className={`p-3 rounded-lg border transition ${
              zeiten[key].aktiv
                ? 'bg-white border-gray-200'
                : 'bg-gray-50 border-gray-100'
            }`}
          >
            <div className="flex items-center gap-4">
              {/* Toggle */}
              <button
                onClick={() => handleToggle(key)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors flex-shrink-0 ${
                  zeiten[key].aktiv ? 'bg-[#378ab2]' : 'bg-gray-300'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    zeiten[key].aktiv ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>

              {/* Tag */}
              <span className={`w-24 font-medium flex-shrink-0 ${
                zeiten[key].aktiv ? 'text-gray-900' : 'text-gray-400'
              }`}>
                {label}
              </span>

              {/* Zeiten */}
              {zeiten[key].aktiv ? (
                <div className="flex items-center gap-2 flex-1 flex-wrap">
                  <div className="flex items-center gap-2">
                    <Clock className="w-4 h-4 text-gray-400 flex-shrink-0" />
                    <input
                      type="time"
                      value={zeiten[key].von}
                      onChange={(e) => handleTimeChange(key, 'von', e.target.value)}
                      className="px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#378ab2] text-sm"
                    />
                    <span className="text-gray-500">-</span>
                    <input
                      type="time"
                      value={zeiten[key].bis}
                      onChange={(e) => handleTimeChange(key, 'bis', e.target.value)}
                      className="px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#378ab2] text-sm"
                    />
                  </div>

                  {/* Mittagspause Toggle */}
                  <button
                    onClick={() => handleMittagspauseToggle(key)}
                    className={`flex items-center gap-1 px-2 py-1 rounded text-sm transition ${
                      zeiten[key].mittagspause
                        ? 'bg-orange-100 text-orange-700'
                        : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                    }`}
                    title="Mittagspause aktivieren/deaktivieren"
                  >
                    <Coffee className="w-3.5 h-3.5" />
                    <span className="hidden sm:inline">Pause</span>
                  </button>

                  {/* Auf Werktage kopieren */}
                  {key !== 'samstag' && key !== 'sonntag' && (
                    <button
                      onClick={() => copyToAll(key)}
                      className="ml-auto text-gray-400 hover:text-[#378ab2] transition flex-shrink-0"
                      title="Auf alle Werktage übertragen"
                    >
                      <Copy className="w-4 h-4" />
                    </button>
                  )}
                </div>
              ) : (
                <span className="text-gray-400 text-sm">Geschlossen</span>
              )}
            </div>

            {/* Mittagspause Zeiten */}
            {zeiten[key].aktiv && zeiten[key].mittagspause && (
              <div className="mt-3 ml-[60px] sm:ml-[140px] flex items-center gap-2 text-sm">
                <Coffee className="w-4 h-4 text-orange-500 flex-shrink-0" />
                <span className="text-gray-600">Pause:</span>
                <input
                  type="time"
                  value={zeiten[key].pauseVon}
                  onChange={(e) => handleTimeChange(key, 'pauseVon', e.target.value)}
                  className="px-2 py-1 border border-orange-200 bg-orange-50 rounded focus:outline-none focus:ring-2 focus:ring-orange-400 text-sm"
                />
                <span className="text-gray-500">-</span>
                <input
                  type="time"
                  value={zeiten[key].pauseBis}
                  onChange={(e) => handleTimeChange(key, 'pauseBis', e.target.value)}
                  className="px-2 py-1 border border-orange-200 bg-orange-50 rounded focus:outline-none focus:ring-2 focus:ring-orange-400 text-sm"
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="bg-blue-50 p-4 rounded-lg text-sm text-blue-800">
        <strong>Tipp:</strong> Klicken Sie auf "Pause", um eine Mittagspause für den jeweiligen Tag zu aktivieren. Mit dem Kopier-Symbol übertragen Sie die Zeiten auf alle Werktage.
      </div>
    </div>
  );
}

export default OeffnungszeitenStep;
